import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_7: FaireProductEntity = {
  token: "atc_nf_chunks_7",
  type: "product",
  name: "Horse Girl Barrette",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/products/Barrette-HorseGirlClip-WBG-web-1.jpg?v=1664585755",
  priceDollars: 15.95,
  msrpDollars: 32,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
